import { SnapshotImage } from 'src/types';

export const CAMERA_SNAPSHOT_TIMESTAMP_SHIFT = 100000;

export function getNewSnapshotTimestamp(roomImages: SnapshotImage[]): number {
  const maxTimestamp = Math.max(...roomImages.map((image) => Number(image.videoTimestamp)));
  const newTimestamp =
    (maxTimestamp >= CAMERA_SNAPSHOT_TIMESTAMP_SHIFT ? maxTimestamp : CAMERA_SNAPSHOT_TIMESTAMP_SHIFT) + 1;
  return newTimestamp;
}
